module.exports = __webpack_public_path__ + "img/Square.8c153b11.svg";